/**
 * Capitalize first character only, leave rest untouched.
 * Preserves "McDonald", "O'Brien" etc.
 */
export const capitalizeFirst = (value) => {
  if (!value || typeof value !== 'string') return value;
  return value.charAt(0).toUpperCase() + value.slice(1);
};

/**
 * Capitalize after start, space, or hyphen.
 * Also capitalizes after single-letter name prefixes with apostrophe (O'Brien, D'Arcy).
 * Does not capitalize possessive 's (Brien's stays Brien's).
 */
export const capitalizeWords = (value) => {
  if (!value || typeof value !== 'string') return value;
  return value
    .replace(/(^|[\s-])\S/g, (match) => match.toUpperCase())
    .replace(/\b(\w)'(\w)/g, (match, before, after) => `${before}'${after.toUpperCase()}`);
};

/**
 * Lowercase entire string. Used for emails/usernames.
 */
export const toLower = (value) => {
  if (!value || typeof value !== 'string') return value;
  return value.toLowerCase();
};
